const cartDrawer = document.querySelector("cart-drawer");
let activeElement = null;

function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);

  if (match) {
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

const setActiveElement = (element) => {
  activeElement = element;
};

const openCartDrawer = (triggeredBy) => {
  if (triggeredBy) setActiveElement(triggeredBy);

  const cartDrawerNote = cartDrawer.querySelector('[id^="Details-"] summary');
  if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
    setSummaryAccessibility(cartDrawerNote);
  }

  setTimeout(() => {
    cartDrawer.classList.add("animate", "active");
  });

  const recartPopupRoot = document.querySelector("#recart-popup-root");
  if (recartPopupRoot) {
    // recartPopupRoot.style.display = "none";
    recartPopupRoot.style.visibility = "hidden";
  }
  updateCartDrawer();
  const html = document.querySelector("html");
  html.style.overflow = "hidden";
};

const closeCartDrawer = () => {
  cartDrawer.classList.add("closing");
  const html = document.querySelector("html");
  document.querySelector("html").classList.remove("cart-drawer-active");
  html.style.overflow = "auto";
  const recartPopupRoot = document.querySelector("#recart-popup-root");
  if (recartPopupRoot) {
    // recartPopupRoot.style.display = "block";
    recartPopupRoot.style.visibility = "visible";
  }

  setTimeout(() => {
    cartDrawer.classList.remove("active", "closing");
  }, 300);
};

const setSummaryAccessibility = (cartDrawerNote) => {
  cartDrawerNote.setAttribute("role", "button");
  cartDrawerNote.setAttribute("aria-expanded", "false");

  const nextElementId = cartDrawerNote.nextElementSibling?.getAttribute("id");
  if (nextElementId) {
    cartDrawerNote.setAttribute("aria-controls", nextElementId);
  }

  cartDrawerNote.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
};

const setHeaderCartIconAccessibility = () => {
  const cartLink = document.querySelector("#cart-drawer-trigger");
  if (cartLink) {
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      openCartDrawer(cartLink);
    });

    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        openCartDrawer(cartLink);
      }
    });
  }
};

// ============================================================
// Remove Shipping Protection if it somehow ends up in cart
// (safety net — SP is no longer added at any point in the UI)
// ============================================================

async function removeOrphanedShippingProtection() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const spItem = cart.items.find(item => item.product_id === 8957611540696);
    if (!spItem) return;
    const otherItems = cart.items.filter(item => item.product_id !== 8957611540696);
    if (otherItems.length === 0) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: spItem.key, quantity: 0 }),
      });
    }
  } catch (err) {
    console.error('removeOrphanedShippingProtection error:', err);
  }
}

// ============================================================
// Dedup: only merge line items that are exact duplicates —
// same variant ID AND same selling plan ID (or both one-time).
// Different plans (30-day vs 60-day) and one-time vs sub
// are intentionally kept as separate line items.
// ============================================================

async function deduplicateCartLineItems() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    // Build a composite key: variantId + sellingPlanId (or 'onetime')
    const groupMap = {};
    for (const item of cart.items) {
      const planId = item.selling_plan_allocation
        ? String(item.selling_plan_allocation.selling_plan.id)
        : 'onetime';
      const compositeKey = `${item.variant_id}__${planId}`;
      if (!groupMap[compositeKey]) groupMap[compositeKey] = [];
      groupMap[compositeKey].push(item);
    }

    const updates = {};
    let hasDupes = false;

    for (const [key, items] of Object.entries(groupMap)) {
      if (items.length < 2) continue;
      hasDupes = true;

      // Keep the first, sum quantities, zero out the rest
      const keepItem = items[0];
      const totalQty = items.reduce((sum, i) => sum + i.quantity, 0);
      updates[keepItem.key] = totalQty;
      for (let i = 1; i < items.length; i++) {
        updates[items[i].key] = 0;
      }
    }

    if (!hasDupes) return false;

    // Single batched update — avoids race conditions
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });

    return true;
  } catch (err) {
    console.error('deduplicateCartLineItems error:', err);
    return false;
  }
}

async function updateCartDrawer() {
  await removeOrphanedShippingProtection();
  await deduplicateCartLineItems();

  const res = await fetch(
    `${window.Shopify.routes.root}?section_id=cart-drawer`
  );
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector("cart-drawer").innerHTML;
  document.querySelector("cart-drawer").innerHTML = newBox;
  addCartDrawerListeners();
  setTimeout(() => {
    FGSECOMAPP.renderPromotionMessage();
    document.dispatchEvent(new CustomEvent('bogos:gifts'));
  }, 100);
}

async function handleGamificationLogic() {
  const gamificationContainer = document.querySelector('.sidecart-gamification');
  if (!gamificationContainer) return;

  const freeGiftId = gamificationContainer.dataset.freeGiftId;
  const goalPrice = parseFloat(gamificationContainer.dataset.goal);
  const isGamificationActive = gamificationContainer.dataset.gamificationEnabled === 'true';

  if (!isGamificationActive || !freeGiftId || !goalPrice) return;

  const response = await fetch('/cart.js');
  const cart = await response.json();
  const currentCartValue = cart.total_price / 100;
  const isGiftInCart = cart.items.some(item => String(item.id) === freeGiftId);

  if (currentCartValue >= goalPrice && !isGiftInCart) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(freeGiftId, 10), quantity: 1 })
    });
    if (res.ok) document.dispatchEvent(new Event('shopify:cart:updated'));
    else console.error("Error adding gift:", res.type);

  } else if (currentCartValue < goalPrice && isGiftInCart) {
    const giftItem = cart.items.find(item => String(item.id) === freeGiftId);
    if (giftItem) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [giftItem.key]: 0 } })
      });
      if (res.ok) document.dispatchEvent(new Event('shopify:cart:updated'));
      else console.error("Error removing gift:", res.type);
    }
  }
}

async function addToCartSubscription(form) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(form),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json();
    })
    .then((data) => {
      updateCartDrawer();
      openCartDrawer();
      updateBubbleCartCount(data.item_count);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

const updateBubbleCartCount = (count) => {
  if (count === undefined) return;
  const cartCount = document.querySelector("#CartCount");
  if (cartCount) cartCount.innerHTML = count;
};

async function handleProductFormSubmit(e) {
  let form;
  if (e instanceof Event) {
    e.preventDefault();
    form = e.currentTarget;
  } else {
    form = e;
  }
  const formData = new FormData(form);
  const button = e.submitter;
  button?.classList.add("loading");
  button?.setAttribute("aria-disabled", "true");

  const data = {};
  for (const [key, value] of formData.entries()) {
    data[key] = value;
  }

  const toggle = form.querySelector('#subToggle');
  if (toggle && toggle.checked) {
    const customDropdown = form.querySelector('#custom-subscription-dropdown');
    if (customDropdown && customDropdown.value) {
      data['selling_plan'] = customDropdown.value;
    }
  } else {
    if (toggle) delete data['selling_plan'];
  }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error adding to cart:', errorData);
      throw new Error('Error adding to cart.');
    }

    const res = await fetch("/cart.js");
    const cart = await res.json();

    await updateCartDrawer();
    updateBubbleCartCount(cart.item_count);
    openCartDrawer();
    setTimeout(() => {
      FGSECOMAPP.renderPromotionMessage();
      document.dispatchEvent(new CustomEvent('bogos:gifts'));
    }, 1000);

  } catch (error) {
    console.error("Error in request:", error);
  } finally {
    button?.classList.remove("loading");
    button?.removeAttribute("aria-disabled");
  }
}

// ============================================================
// FBT Swiper — ensures both CSS and JS are loaded before init
// ============================================================

function loadSwiperCSS() {
  return new Promise((resolve) => {
    const existing = document.querySelector('link[href*="swiper-bundle.min.css"]');
    if (existing) {
      if (existing.sheet) {
        resolve();
      } else {
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', resolve);
      }
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    link.addEventListener('load', resolve);
    link.addEventListener('error', resolve);
    document.head.appendChild(link);
  });
}

function loadSwiperScript() {
  return new Promise((resolve) => {
    if (window.Swiper) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = resolve;
    script.onerror = resolve;
    document.head.appendChild(script);
  });
}

async function initFbtSwiper() {
  const el = document.querySelector('.js-fbt-swiper');
  if (!el) return;

  await Promise.all([loadSwiperCSS(), loadSwiperScript()]);

  if (el.swiper) el.swiper.destroy(true, true);

  const section = el.closest('.fbt-section');
  const prevBtn = section?.querySelector('.fbt-nav-bar__prev');
  const nextBtn = section?.querySelector('.fbt-nav-bar__next');
  const paginationEl = section?.querySelector('.fbt-swiper__pagination');

  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: false,
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    navigation: {
      prevEl: prevBtn,
      nextEl: nextBtn,
    },
  });
}

// ============================================================
// Tooltip positioning — keeps bubble within viewport
// ============================================================

function setupTooltipPositioning() {
  const margin = 16;
  const gap = 8;

  document.addEventListener('mouseover', (e) => {
    const tooltip = e.target.closest('.cart-protection-tooltip');
    if (!tooltip) return;

    const bubble = tooltip.querySelector('.cart-protection-tooltip__text');
    if (!bubble) return;

    bubble.style.top = '-9999px';
    bubble.style.left = '-9999px';
    bubble.classList.add('is-visible');

    requestAnimationFrame(() => {
      const iconRect = tooltip.getBoundingClientRect();
      const bubbleWidth = bubble.offsetWidth;
      const bubbleHeight = bubble.offsetHeight;

      let top = iconRect.top - bubbleHeight - gap;

      if (top < margin) {
        top = iconRect.bottom + gap;
        bubble.classList.add('tooltip--below');
      } else {
        bubble.classList.remove('tooltip--below');
      }

      let left = iconRect.left + (iconRect.width / 2) - (bubbleWidth / 2);
      left = Math.max(margin, Math.min(left, window.innerWidth - bubbleWidth - margin));

      bubble.style.top = `${top}px`;
      bubble.style.left = `${left}px`;
    });
  });

  document.addEventListener('mouseout', (e) => {
    const tooltip = e.target.closest('.cart-protection-tooltip');
    if (!tooltip) return;
    const bubble = tooltip.querySelector('.cart-protection-tooltip__text');
    if (!bubble) return;
    bubble.classList.remove('is-visible', 'tooltip--below');
  });
}

function setupDynamicListeners() {
  if (!cartDrawer) return;

  cartDrawer.addEventListener("click", async (event) => {

    const overlayElement = event.target.closest("#CartDrawer-Overlay");
    if (overlayElement) {
      closeCartDrawer();
      return;
    }

    const closeButton = event.target.closest(".drawer__close");
    if (closeButton) {
      closeCartDrawer();
      return;
    }

    const button =
      event.target.closest(".quantity__button") ||
      event.target.closest("cart-remove-button");

    if (!button) return;

    event.preventDefault();

    const rootItem = button.closest("[data-line-item-key]");
    const key = rootItem ? rootItem.getAttribute("data-line-item-key") : null;
    if (!key) return;

    let newQuantity = 0;
    let fetchBody = {};

    if (button.classList.contains("quantity__button")) {
      const quantityInput = button.parentElement.querySelector("input");
      const currentQuantity = Number(quantityInput.value);
      newQuantity = button.name === "plus" ? currentQuantity + 1 : currentQuantity - 1;
      fetchBody = { updates: { [key]: newQuantity } };
    } else if (button.tagName === "CART-REMOVE-BUTTON") {
      newQuantity = 0;
      fetchBody = { updates: { [key]: 0 } };
    } else {
      return;
    }

    if (newQuantity >= 0) {
      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fetchBody),
      });

      const cart = await res.json();
      updateCartDrawer();
      updateBubbleCartCount(cart.item_count);
      setTimeout(() => {
        FGSECOMAPP.renderPromotionMessage();
        document.dispatchEvent(new CustomEvent('bogos:gifts'));
      }, 1000);
    }
  });

  cartDrawer.addEventListener("change", async (event) => {
    const checkbox = event.target.closest(".input-selling");
    const select = event.target.closest(".selling-plan-select");

    if (checkbox) {
      const lineItemKey = checkbox.dataset.lineItemKey;
      const sellingPlanId = checkbox.checked ? checkbox.dataset.sellingPlanId : null;
      const cartItem = checkbox.closest(".cart-item");
      const quantityInput = cartItem?.querySelector(".quantity__input");
      const currentQuantity = quantityInput?.value || 1;
      const selectWrapper = cartItem?.querySelector(".selling-plan-select-wrapper");
      const planSelect = cartItem?.querySelector(".selling-plan-select");

      if (selectWrapper && planSelect) {
        if (checkbox.checked) {
          selectWrapper.classList.remove("subscription-disabled");
          planSelect.disabled = false;
        } else {
          selectWrapper.classList.add("subscription-disabled");
          planSelect.disabled = true;
        }
      }

      checkbox.disabled = true;

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lineItemKey,
            selling_plan: sellingPlanId,
            quantity: currentQuantity,
          }),
        });
        if (!response.ok) throw new Error("Error updating cart");
        await response.json();
        updateCartDrawer();
      } catch (error) {
        console.error("Failed to update subscription:", error);
        checkbox.checked = !checkbox.checked;
        if (selectWrapper && planSelect) {
          if (checkbox.checked) {
            selectWrapper.classList.remove("subscription-disabled");
            planSelect.disabled = false;
          } else {
            selectWrapper.classList.add("subscription-disabled");
            planSelect.disabled = true;
          }
        }
        await updateCartDrawer();
      } finally {
        checkbox.disabled = false;
      }

    } else if (select) {
      const sellingPlanId = select.value || null;
      const lineItemKey = select.dataset.lineItemKey;
      const cartItem = select.closest(".cart-item");
      const quantityInput = cartItem?.querySelector(".quantity__input");
      const currentQuantity = quantityInput?.value || 1;

      select.disabled = true;

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lineItemKey,
            selling_plan: sellingPlanId,
            quantity: currentQuantity,
          }),
        });
        if (!response.ok) throw new Error("Error updating cart with selling plan");
        await response.json();

        const checkboxEl = cartItem?.querySelector(".input-selling");
        if (checkboxEl) checkboxEl.checked = !!sellingPlanId;

        await updateCartDrawer();
        setTimeout(() => {
          FGSECOMAPP.renderPromotionMessage();
          document.dispatchEvent(new CustomEvent('bogos:gifts'));
        }, 1000);
      } catch (error) {
        console.error("Failed to update selling plan:", error);
      } finally {
        select.disabled = false;
      }
    }
  });

  cartDrawer.addEventListener("submit", (event) => {
    const fbtForm = event.target.closest(".fbt-form .form-product");
    if (fbtForm) {
      event.preventDefault();
      handleProductFormSubmit(fbtForm);
    }
  });

  cartDrawer.addEventListener(
    "keyup",
    (evt) => evt.code === "Escape" && closeCartDrawer()
  );
}

function setupStaticListeners() {
  if (!cartDrawer) return;

  document.querySelectorAll(".group-product__form").forEach((form) => {
    form.addEventListener("submit", handleProductFormSubmit);
  });

  document.querySelectorAll(".group-product__form2").forEach((form) => {
    form.addEventListener("submit", handleProductFormSubmit);
  });
  document.querySelectorAll(".rca-add-to-cart-submit").forEach((form) => {
    form.addEventListener("submit", handleProductFormSubmit);
  });

  document.querySelectorAll(".shg-btn").forEach((button) => {
    button.addEventListener("click", (event) => {
      const href = button.getAttribute("href");
      const idMatch = href.match(/id=(\d+)/);
      const sellingPlanMatch = href.match(/selling_plan=(\d+)/);
      if (!idMatch || !sellingPlanMatch) return;

      event.preventDefault();

      const payload = {
        items: [{
          id: parseInt(idMatch[1], 10),
          quantity: 1,
          selling_plan: parseInt(sellingPlanMatch[1], 10),
        }],
      };
      addToCartSubscription(payload);
    });
  });

  document.addEventListener("ssp:cart:update", () => {
    updateCartDrawer();
    setTimeout(() => {
      console.log("Retrying cart update after 0.5s");
      updateCartDrawer();
    }, 500);
  });

  document.addEventListener("shopify:cart:updated", () => {
    updateCartDrawer();
  });

  setHeaderCartIconAccessibility();
}

async function initCart() {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  updateBubbleCartCount(cart.item_count);
  setTimeout(() => {
    updateCartDrawer();
  }, 500);
}

async function addCartDrawerListeners() {
  await handleGamificationLogic();
  initFbtSwiper();
}

window.addEventListener("pageshow", async function (event) {
  if (event.persisted) {
    // Coming back from checkout — deduplicate first, then sync cart
    await deduplicateCartLineItems();
    initCart();
  }
});

document.addEventListener("DOMContentLoaded", async () => {
  // Deduplicate on page load in case checkout created dupes
  await deduplicateCartLineItems();
  setupStaticListeners();
  setupDynamicListeners();
  addCartDrawerListeners();
  initCart();
});